export const MainMenuPage = (destinationLang) => {
  return [
    {
      FormKey: 'main-menu-button-current-patient',
      Key: 'بيماران جاري',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-patients-list',
      Key: 'ليست بيماران',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-new-refferal',
      Key: 'ارجاع جديد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-performance-report',
      Key: 'گزارش عملکرد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-upload-file',
      Key: 'بارگذاري فايل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-wage',
      Key: 'حق الزحمه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-get-appointment',
      Key: 'اخذ نوبت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-appointments',
      Key: 'نوبت ها',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-canceled-appointments',
      Key: 'نوبت هاي لغو شده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-invoice-receipt',
      Key: 'فیش حقوقی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-lab-actions',
      Key: 'آزمایشگاه تشخیصی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-pato-actions',
      Key: 'تایید فرم',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-pacs-images',
      Key: 'تصاویر پزشکی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-dialog-max-size-exceeded-upload',
      Key: 'حداکثر حجم تصویر بایستی 400 کیلوبایت باشد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-button-patient-send-file',
      Key: 'ارسال فایل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'main-menu-desktop-sidebar-profile-accordion',
      Key: 'پروفایل من',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-devider-label-personel-wage',
      Key: 'پرسنلی و حقوق',
      DistinitationLanguage: destinationLang,
    },
  ];
};
